/**
 * Helpers Functions
 */
import moment from 'moment';
import numeral from 'numeral';
import geos from '@/assets/jsondata/provinces.json'
import countries from '@/assets/jsondata/country-th.json'

// Get Date
export function getTheDate(timestamp, format) {
	let time = timestamp * 1000;
	let formatDate = format ? format : 'MM-DD-YYYY';
	return moment(time).format(formatDate);
}

// Convert Date To Timestamp
export function convertDateToTimeStamp(date, format) {
	let formatDate = format ? format : 'YYYY-MM-DD';
	return moment(date, formatDate).unix();
}

/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
	if (length == null) {
		length = 100;
	}
	if (ending == null) {
		ending = '...';
	}
	if (str.length > length) {
		return str.substring(0, length - ending.length) + ending;
	} else {
		return str;
	}
}

/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
	var c;
	if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
		c = hex.substring(1).split('');
		if (c.length === 3) {
			c = [c[0], c[0], c[1], c[1], c[2], c[2]];
		}
		c = '0x' + c.join('');
		return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
	}
	throw new Error('Bad Hex');
}

/**
 * Function to return currenr app layout
 */
export function getCurrentAppLayout(router) {
	let location = router.history.current.fullPath;
	let path = location.split("/")
	return path[1];
}

/** 
 * Function to return array unigue
*/
export function ArrayUnique(value, index, self) { 
	return self.indexOf(value) === index;
}

/**
 * Get a random integer between `min` and `max`.
 * 
 * @param {number} min - min number
 * @param {number} max - max number
 * @return {number} a random integer
 */
export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function ldapTimeToUnixTime(ldapTime) {
  let secsAfterADEpoch = ldapTime / 10000000;
  let ADToUnixConverter = ((1970 - 1601) * 365 - 3 + round((1970 - 1601) / 4)) * 86400;
  return parseInt(secsAfterADEpoch) - parseInt(ADToUnixConverter);
}

/**
 * Get startDate and endDate.
 * 
 * @param {Date} endDate
 * @param {number} range
 * @return {Object}
 */
export function getDateRange(endDate, range = 7) {
  const start = moment(endDate, "YYYY-MM-DD HH:mm:ss").subtract(range, 'days').format('YYYY-MM-DD')
  const end = moment(endDate, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD')

  return {
    startdate: start,
    enddate: end,
    range: range
  }
}


/**
 * Set Default Filters Region.
 * 
 * @param {String} region
 * @return {Array} 
 */
export function setDefaultFiltersRegion(region) {
  let provinces = []
  
  switch (region) {
    case 'north': {
      provinces = geos[0].PROVINCES.map((province) => {
        return province.PROVINCE_NAME
      })
      provinces.push(
        'สุโขทัย',
        'ตาก',
        'พิษณุโลก',
        'อุทัยธานี'
      )
      break;
    }
    case 'central': {
      provinces = geos[1].PROVINCES.map((province) => {
        return province.PROVINCE_NAME
      })

      provinces.push(
        'กาญจนบุรี',
        'ประจวบคีรีขันธ์'
      )
      break;
    }
    case 'eastern': {
      provinces = geos[4].PROVINCES.map((province) => {
        return province.PROVINCE_NAME
      })

      provinces.push('นครนายก')
      break;
    }
    case 'northeastern': {
      provinces = geos[2].PROVINCES.map((province) => {
        return province.PROVINCE_NAME
      })
      break;
    }
    case 'southern': {
      provinces = geos[5].PROVINCES.map((province) => {
        return province.PROVINCE_NAME
      })
      break;
    }
  }

  return provinces
}

/**
 * Set Default Filters Region.
 * 
 * @param {String} region
 * @return {Array} 
 */
export function setDefaultFiltersForeignRegion(region) {
  let countries = []
  
  switch (region) {
    case 'east-asia': {
      countries = [
        'ญี่ปุ่น',
        'ไต้หวัน',
        'เกาหลีใต้',
        'ฮ่องกง',
        'จีน'
      ]
      break;
    }
    case 'asian': {
      countries = [
        'ออสเตรเลีย',
        'มาเลเซีย',
        'สิงคโปร์',
        'อินเดีย',
        'เวียดนาม',
        'อินโดนีเซีย'
      ]
      break;
    }
    case 'europe': {
      countries = [
        'อังกฤษ',
        'เยอรมนี',
        'ฝรั่งเศส',
        'อิตาลี',
        'สวีเดน',
        'รัสเซีย',
        'สหรัฐอาหรับเอมิเรตส์'
      ]
      break;
    }
    case 'america': {
      countries = [
        'สหรัฐ'
      ]
      break;
    }
  }

  return countries
}

export function isMobile() { 
  if( navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i)
  ){
     return true;
   }
  else {
     return false;
   }
 }

 /**
 * Calculate total value from current year between year ago to percent
 * 
 * @param {Float} current_value
 * @param {Float} ago_value
 * @return {String} 
 */
 export function calculatePercentBetweenYear(current_value = 0, ago_value = 0) {

  let percent_value = 0;
      current_value = current_value > 0 ? numeral(current_value.toString()).value() : 0;
      ago_value = ago_value > 0 ? numeral(ago_value.toString()).value() : 0;

  if (current_value > 0 && ago_value > 0) {
      percent_value = (parseFloat(current_value) - parseFloat(ago_value)) * 100 / parseFloat(ago_value);
      percent_value = percent_value.toFixed(2)
      //percent_value = parseFloat(percent_value) <= 100 ? percent_value.toFixed(2) : 100;
      percent_value = percent_value.toString().indexOf('-') ==-1 ? '+'+percent_value : percent_value;
  }
  return percent_value;
 }

 /**
 * Calculate price for display short
 * 
 * @param {Float} total_price
 * @return {String} 
 */
export function calculateShortPrice(price = 0, display_type = 'price',show_unit = false) {

  let format_number = display_type =='price' ? '0,0.00' : '0,0';
  // hundred-thousand 10^5, million 10^6 ,ten-million 10^7, hundred-million 10^8
  // billion 10^9, ten-billion 10^10, hundred-billion 10^11 ,trillion 10^12
  let total_price = price > 0 ? numeral(price.toString()).value() : 0;
  let convert_price = display_type == 'quantity' ? numeral(total_price).format(format_number) : numeral(total_price / Math.pow(10, 6)).format(format_number)
  let unit_display = '';

  if (total_price >= Math.pow(10, 6) && total_price < Math.pow(10, 11)) {
    // ล้าน
    //total_price = numeral(total_price / Math.pow(10, 6)).format('0,0.00');
    unit_display = show_unit === true ? 'ล้าน' :'';
    total_price = convert_price;
  } else if (total_price >= Math.pow(10, 11) && total_price < Math.pow(10, 12)) {
    // แสนล้าน
    unit_display = show_unit === true ? 'ล้าน' :'';
    total_price = convert_price;
  } else if (total_price >= Math.pow(10, 12)) {
    // ล้านล้าน
    unit_display = show_unit === true ? 'ล้าน' :'';
    total_price = convert_price;
    //total_price = numeral(total_price / Math.pow(10, 12)).format('0,0.00') + " ล้านล้าน";
  } else {
    total_price = numeral(total_price).format(format_number);
  }
  return total_price+' '+unit_display;
 }

 export function calculateNormalPercent(value = 0, total_value = 0) {
  if (total_value == 0) {
    return 0;
  }
  let calculate = (parseFloat(value) / parseFloat(total_value)) * 100;
  let percent = numeral(calculate).format('0,0.00')

  return percent;
 }

 export function requestDesktopSite() {
  const site_view = localStorage.getItem('site_view') || 'desktop';
  localStorage.setItem('site_view', 'desktop')
  if (document.getElementsByTagName('meta')['viewport'].content=='width=device-width, initial-scale=1.0') {
   document.getElementsByTagName('meta')['viewport'].content='width=1366px';
   document.querySelector('.buttonSwitchSiteView').innerHTML = 'Mobile View';
   localStorage.setItem('site_view', 'desktop')
  } else {
   document.getElementsByTagName('meta')['viewport'].content='width=device-width, initial-scale=1.0';
   document.querySelector('.buttonSwitchSiteView').innerHTML = 'Desktop View';
   localStorage.setItem('site_view', 'mobile')
  }
 }

 export function getNumberScales(minRange, maxRange, min, max) {
  var scales = [],                  // Prepare some variables
  ranges = maxRange + 1 - minRange,   // Amount of elements to be returned.
  range  = (max - min) / ranges;        // Difference between min and max
  for(var i = 0; i < ranges; i++){
      scales.push({
          range: i + minRange,        // Current range number
          min: min + range * i,
          max: min + range * (i + 1)
      });
  }
  return scales;
}